/* ==========================================================================
   KB swatch image swap - delegated fallback

   Each product grid binds its own swatch handler inside its section script.
   Those bind on page load against the elements present at that moment, so a
   swatch stops responding if the section's script throws earlier for any
   reason, or if cards are swapped in later by a filter or load-more.

   This listens on document instead, so it keeps working in both cases. It is
   a no-op when a section's own handler already ran, because that handler
   calls preventDefault and this one checks for it.
   ========================================================================== */
(function () {
  if (window.__kbSwatchSwap) return;
  window.__kbSwatchSwap = true;

  /* swatch selector -> [card selector, image selector] */
  var GRIDS = [
    ['.kb-col__card-swatch', '.kb-col__card', '.kb-col__card-img'],
    ['.kb-fc__swatch-wrap', '.kb-fc__card', '.kb-fc__card-img'],
    ['.kb-ft__swatch-wrap', '.kb-ft__card', '.kb-ft__card-img']
  ];

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;

      for (var i = 0; i < GRIDS.length; i++) {
        var sel = GRIDS[i];
        var swatch = e.target.closest(sel[0]);
        if (!swatch) continue;

        var imageUrl = swatch.dataset.image;
        if (!imageUrl) return;

        /* The section's own handler got here first and did the work */
        if (e.defaultPrevented) return;

        var card = swatch.closest(sel[1]);
        if (!card) return;
        var img = card.querySelector(sel[2]);
        if (!img) return;

        e.preventDefault();
        /* A srcset candidate beats src, so clear it before swapping */
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = imageUrl;
        card.querySelectorAll(sel[0]).forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
        return;
      }
    },
    false
  );
})();
